<template>
	<span>
		<button class="flex-shrink-0 mr-8 align-middle" @click="isOpen = !isOpen">
			<BaseIcon v-if="isOpen" name="mono/triangle-down" />
			<BaseIcon v-else name="mono/triangle-right" />
			<span class="mx-8"><slot>Array</slot>({{ value.length }})</span>
			<span v-if="isOpen">[</span>
		</button>
		<div v-if="isOpen" style="margin-left: 20px">
			<div v-for="(item, index) of value" :key="index" class="flex">
				<span class="mr-8">{{ index }}:</span>
				<ConsoleEventArg renderAs="ArgValue" :serialized="serialized" :value="item" />
			</div>
		</div>
		<div v-if="isOpen">]</div>
	</span>
</template>

<script>
export default {
	name: 'ArgArray',
	props: {serialized: Object, value: Array},
	data() {
		return {
			isOpen: false,
		}
	},
}
</script>
